import { History } from 'lucide-react'
import { StubPage } from './StubPage'

export function LogsPage() {
  return (
    <StubPage
      title="Logs"
      icon={History}
      phase="Coming in Phase 4 — admin dashboard rollout"
      description={
        <>
          An audit-log surface lives here: timestamp, actor, workspace, event,
          target, with filters for date range / workspace / event type / actor and
          CSV export.
          <br />
          <br />
          Storage will be a new <code>audit_logs</code> table (kept separate from
          the per-company <code>activities</code> module — those are user-visible
          timeline content, audit logs are admin-only and need different retention).
          Events captured: auth (login/logout/refresh fail), company CRUD, user
          CRUD + role change + deactivation, lead/deal create + delete + assignment
          change, settings mutations, webhook deliveries.
        </>
      }
    />
  )
}
